import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import moment from "moment";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { TopBar } from '../../shared/topBar/TopBar';
import { useDispatch, useSelector } from 'react-redux';
import { DateRangePicker } from "rsuite";
import { SBADropDown, SBAMultiSelectCheck } from "../../UiComponents/SBADropDown";
import { getAllUsers } from "../../actions/UserAction";
import download from "../../../Images/download.svg";
import { sbaAxios } from "../../utils/sbaAxios";
import { DownloadDocument, deleteInvestorTracking, getCustomSettings, getDocbyActivityId, getUserPageAccess } from "../../../config/apiConfig";
import { getInvestorTrackingList, getTransactionTypes, getInvestorAssetAction, getInvestorPortfolioAction, getinvestorstatusAction } from "../../actions/investorTrackingAction";
import { getFamiliesAction } from "../../actions/CommonAction";
import { excelStyles, exportToExcelUsingRef } from '../../utils/excelExporter';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { getTransactionsMenuList } from "../../actions/assetTransactionsAction";
import { flatChildren } from "@progress/kendo-react-all";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { AgGridReact } from "ag-grid-react";

export const InvestorTrackingList = () => {
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const isEditable = Gstate.authorizationData.isEditable;
  const AssetListDDL = useSelector(state => state.assetDDL.assetList);
  const users = useSelector((state) => state.Users.Users);

  const InvestorTrackingList = Gstate.investortrackingList.investortrackingList || [];
  const TrackerGridLoading = useSelector((state) => state.investortrackingList.isLoading);
  const Family = Gstate.common.Family || [];
  const TransactionTypes = Gstate.investortrackingList.transactionTypes || [];
  const Portfolios = Gstate.investortrackingList.investorPortfolio || [];
  const Assets = Gstate.investortrackingList.investorAssets || [];
  const Status = Gstate.investortrackingList.investorStatus || [];
  // const currentDate = new Date();
  // const startDate = new Date(currentDate);
  // startDate.setFullYear(currentDate.getFullYear() - 1);
  // const endDate = currentDate;
  // const formattedStartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
  // const formattedEndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;
  const currentDate = moment();
  const startOfMonth = currentDate.clone().startOf('month');
  const endDate = startOfMonth.clone().add(1, 'year');
  const dispatch = useDispatch();
  const [portfolio, setPortfolio] = useState(Portfolios);
  const [portfolioIds, setPortfolioIds] = useState([]);

  const [asset, setAsset] = useState(Assets);
  const [assetId, SetAssetId] = useState([]);

  const [investorTrackingId, setinvestorTrackingId] = useState([null]);

  const [familyIds, SetfamilyIds] = useState([]);
  const [families, Setfamilies] = useState(Family);

  const [types, settypes] = useState(TransactionTypes);
  const [typeIds, settypeIds] = useState([]);

  const [statusIds, SetstatusIds] = useState([]);
  const [status, Setstatus] = useState(Status);
  const [TBD, setTBD] = useState(false);
  const [groupId, SetgroupId] = useState([null]);
  // const [StartDate, setStartDate] = useState(moment(formattedStartDate).format('MM-DD-YYYY'));
  // const [EndDate, setEndDate] = useState(moment(formattedEndDate).format('MM-DD-YYYY'));
  const [StartDate, setStartDate] = useState(startOfMonth.format('MM-DD-YYYY'));
  const [EndDate, setEndDate] = useState(endDate.format('MM-DD-YYYY'));
  const [customRange, setCustomRange] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ UserId: -1, Fullname: "Please Select" });
  const [UserId, SetUserId] = useState(null);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [colDef, setColDef] = useState([]);
  const investorGridRef = useRef();
  const [gridApi, setGridApi] = useState();
  const [render, setRender] = useState(0);
  const [dateRange, setDateRange] = useState([new Date(StartDate), new Date(EndDate)]);
  const [isHovered, setIsHovered] = useState(false);
  const history = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [reasonForDeleting, setReasonForDeleting] = useState('');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedInvestorIds, setSelectedInvestorIds] = useState([]);
  const [showPDFModal,setShowPDFModal]=useState(false);
  const [PDFList,setPDFList]=useState([]);
  const [bulkEditAccess,setBulkEditAccess]=useState(false);
  const getBulkEditAccess = () => {
    sbaAxios({ url: `${getUserPageAccess}?keyName=InvestorTrackingBulkEditAccess` }).then(res => {
        setBulkEditAccess(res);
    }).catch(er => {
      setBulkEditAccess(false);
    });
};
useEffect(()=>{
  getBulkEditAccess()
},[])
  useEffect(() => {
    document.title = "Investor";
    dispatch(getAssestListddlAction());
    fetchGridData();
    dispatch(getAllUsers());
    dispatch(getFamiliesAction());
    dispatch(getTransactionTypes());
    dispatch(getInvestorTrackingList(investorTrackingId, familyIds, portfolioIds, assetId, statusIds, typeIds, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy"), groupId, TBD));
    dispatch(getInvestorPortfolioAction(familyIds, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy")));
    dispatch(getInvestorAssetAction(familyIds, portfolioIds, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy")));
    dispatch(getinvestorstatusAction());
  }, [render]);

  const onSelectionChanged = (params) => {
    const selectedRows = params.api.getSelectedRows();
    const investorIds = selectedRows.map(row => row.InvestorTrackingId);
    setSelectedInvestorIds(prevSelected => [...investorIds]);

  };
  const DocumentRenderer=(props)=>{
    const activtyId=props.data.ActivityId || 0;
    if(activtyId>0)
    {
      sbaAxios({url:getDocbyActivityId+activtyId})
      return <>
      
      </>
    }
    
  };
  const getDocumentCount=(ActivityId)=>{
    sbaAxios({ url: getDocbyActivityId + ActivityId }).then(res => { 
      if(res.length==1)
      {
        pdfview(res[0].DocumentId,res[0].DocumentExtension);
      }
      if(res.length>1)  
      {
        setPDFList(res);
        setShowPDFModal(true);
      }

     })
    // setShowPDFModal(true);
  }

  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({ url: `${getCustomSettings}1010` });

      if (response) {

        const apiColDef = JSON.parse(response.CustomSettingsValue);
        console.log('column defs: ', apiColDef);
        const apiFilters = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
        const hiddenColumns = ["WireInfoSent", "IsPartialRedemption", "IsNewAsset"];
        // Remove columns that include "isSelected"
        const filteredColDef = apiColDef.filter(item => !item.colId.includes("isSelected"));
        const formattedDef = filteredColDef.map(item => {
          if (item.colId == "Documents") {
            return {
              headerName: "Documents", field: "Documents", tooltipComponent: ToolTip, tooltipField: "Documents", maxWidth: 100, cellStyle: { cursor: 'pointer' }, cellRenderer: (props) => {
                return <>{props?.data?.ActivityId > 0 && <><i className="far fa-file-pdf text-danger SBA_hand" onClick={() => {
                  getDocumentCount(props?.data?.ActivityId);
                }} /></>}</> 
              },
              filter:false
            }
          }
          return {
            ...item,
            "field": item.colId,
            valueFormatter: item.colId === "TransactionDate" ? getDateFormatted : null,
            cellRenderer: item.colId === "Action" ? ActionsRenderer : item.colId === "TransactionAmount" ? FormatCurrencyGrid : item.colId === "TransactionPercentage" ? FormatpercentCurrencyGrid : item.colId === "ChartPlotWeight" ||
              item.colId === "IsPartialRedemption" ||
              item.colId === "IsNewAsset"
              ? (props) => CheckBoxRender(props)
              : null,
            cellStyle: { textAlign: (item.colId === "TransactionAmount" || item.colId === "TransactionPercentage") ? "right" : "left" }, // Adjust "NumericColumn" as needed 
            hide: hiddenColumns.includes(item.colId),// Hide specific columns
            headerName: item.colId === "SelectCol" ? "Select" : null,
            checkboxSelection: item.colId === "SelectCol" ? true : null,
            // ✅ Ensure all columns have the correct filter
            filter: item.colId === "SelectCol" ? "agSetColumnFilter" : item.colId != "Documents" ? "agTextColumnFilter" : false,
            cellClass:item.colId === "TransactionAmount" ? "currencyFormat" : item.colId === "TransactionDate"  ? "dateType" : item.colId === "TransactionPercentage" ? "percentageFormat" : null,
            filterParams: item.colId === "SelectCol" ? {
              values: ['Checked', 'Unchecked'],
              valueGetter: (params) => {
                return params.node.selected ? 'Checked' : 'Unchecked';
              },
              comparator: function(filterValue, value, filterItem) {  // Corrected parameters
                if (!filterValue) {
                  return 0; // Show all rows when no filter is applied
                }
                const isChecked = filterValue === 'Checked';
                const rowIsSelected = value === 'Checked';
                return isChecked === rowIsSelected ? 0 : -1;
              }
            } : null,
            
// cellClass
          //new comparator ends
          
          
          
            
          };
        });
        return { columns: formattedDef };
      }

    }
    catch (error) {
      console.log(error);
      throw error;
    }
  };
  
  const CheckBoxRender = (props) => {
    const onChange = (event) => {
        const newValue = event.target.checked;
        
        // ✅ Update the actual row value in AG Grid
        props.node.setDataValue(props.colDef.field, newValue);

        // ✅ Refresh the grid so filtering works properly
        props.api.refreshCells({ rowNodes: [props.node], columns: [props.colDef.field] });
    };

    return (
        <div className="actions-cell">
            <input
                type="checkbox"
                className="mb-0"
                checked={props.value === true} // ✅ Ensure correct checked state
                onChange={onChange} 
            />
        </div>
    );
};

  const fetchGridData = async () => {

    try {
      const customSettings = await getCustomSetting();
      const columns = customSettings?.columns.filter(item => item.colId !== "Select").map(item => ({ ...item }));
      setColDef(columns);
      setAppliedFilter(customSettings.filters);

    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };

  const handleListMouseEnter = () => {
    setIsHovered(true);
  };

  const handleListMouseLeave = () => {
    setIsHovered(false);
  };



  const AssetDDChanged = (e) => {
    SetAssetId([...e.value]);
    const Id = e.value.map(item => item.AssetId).join(',');
  };
  const PortfolioChanged = (e) => {
    setPortfolio([...e.value]);
    const Id = e.value.map(item => item.PortfolioId).join(',');
    const familyId = familyIds.map(item => item.FamilyId).join(',');
    setPortfolioIds(e.value);
    dispatch(getInvestorAssetAction(familyId, Id, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy")));


  }
  const statusChanged = (e) => {
    SetstatusIds([...e.value]);
  };
  const CreatoronChange = (e) => {
    SetUserId(e.value.UserId)
    setSelectedUser(e.value);
  }

  const handleDateChange = (e) => {
    const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
    const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
    setDateRange([newStartDate, newEndDate])
    setCustomRange(true);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  const TransactionTypeDDChanged = (e) => {
    settypeIds([...e.value]);
  }
  const getDateFormatted = (params) => {
    const isoDate = params.value;
    const formattedDate = moment(isoDate).format("MM-DD-YYYY");
    return formattedDate;
  };
  const FormatCurrencyGrid = (params) => {

    var num = params.value;

    if (num !== undefined) {
      // Check if the value is negative
      const isNegative = num < 0;

      // Remove negative sign and format with parentheses
      const formattedValue = isNegative
        ? `($${Math.abs(num).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })})`
        : `$${num.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`;

      // Apply red color for negative values
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;
    } else {
      return num;
    }
  };
  const FormatpercentCurrencyGrid = (params) => {

    var num = params.value;

    if (num !== undefined && num != null) {
      if (num === 0) {
        num = 0;
      }

      // Check if the value is negative
      const isNegative = num < 0;

      // Remove negative sign and format with parentheses
      const formattedValue = isNegative
        ? `${(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} %`
        : `${num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} %`;

      // Apply red color for negative values
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;

    } else {
      return <span></span>; // Wrap num in a span
    }
  };


  const defaultColDef = {
    sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',
  }
  const navigateToTrackingEdit = (TransData) => {
    const transTypeid = TransData.TransactionTypeId;
    const InvestorTrackingId = TransData?.InvestorTrackingId || 0;
    if (transTypeid === 3)
      history(`${UrlPath.InvestorTrackingSubscription}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }
      });
    if (transTypeid === 23)
      history(`${UrlPath.InvestorTrackingCommitment}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }
      });
    if (transTypeid === 24)
      history(`${UrlPath.InvestorTrackingCapitalCall}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }
      });
    if (transTypeid === 4)
      history(`${UrlPath.InvestorTrackingRedemption}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }
      });
    if (transTypeid === 25)
      history(`${UrlPath.InvestorTrackingDistribution}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }

      });
    if (transTypeid === 100)
      history(`${UrlPath.InvestorTrackingRedeemFee}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }

      });
    if (transTypeid === 101)
      history(`${UrlPath.InvestorTrackingRedeemReallocate}${InvestorTrackingId}`, {
        state: {
          groupId: TransData?.TransactionGroupId, mode: "Edit"
        }

      });


  }
  const deleteTransactionTracker = async (id, text) => {
    return await sbaAxios({ url: `${deleteInvestorTracking}?investorTrackingId=${id}&reasonForDeleting=${text}` });
  }

  const ActionsRenderer = (props) => {
    const TrackerId = props.data.InvestorTrackingId;
    const InvestorTrackingStatusId = props.data.InvestorTrackingStatusId;

    return (
      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => { navigateToTrackingEdit(props.data) }}></i>
        <i className="fa fa-trash" disabled={InvestorTrackingStatusId==9} onClick={() => {if( InvestorTrackingStatusId!=9){ setShowDelete(true); setSelectedTransaction(TrackerId); }}} style={{ color: InvestorTrackingStatusId==9 ? 'grey' : "#DF001B", margin: "0 8px", cursor: "pointer" }}></i>
      </div>)

  };

  const bulkuploadclick = () => {
    history(`${UrlPath.InvestorTrackingBulkUpload}`, { state: { investorTrackingIds: selectedInvestorIds } })
  }
  var columnDefs = [
    {
      field: "TransactionDate",
      headerName: "Transaction Date",
    },
    {
      field: "InvestorTrackingStatusName",
      headerName: "Status",

    },
    {
      field: "FamilyName",
      headerName: "Family",

    },
    {
      field: "PortfolioName",
      headerName: "Portfolio",

    },
    {
      field: "AssetName",
      headerName: "Asset",

    },
    {
      field: "ShareClassName",
      headerName: "Share Class",

    },
    {
      field: "TransactionTypeName",
      headerName: "Transaction Type",

    },
    {
      field: "TransactionPercentage",
      headerName: "Percent",
      cellStyle: { textAlign: "right" },
    },
    {
      field: "TransactionAmount",
      headerName: "Amount",
      cellStyle: { textAlign: "right" },
      //  valueFormatter: FormatCurrencyGrid,
    },
    {
      field: "WireInfoSent",
      headerName: "Wire Info Sent",
    },
    {
      field: "IsPartialRedemption",
      headerName: "Partial",
    },
    {
      field: "IsNewAsset",
      headerName: "New Asset",
    },
    {
      field: "Notes",
      headerName: "Notes",
    },
    {
      field: "",
      headerName: "Action",
      cellRenderer: ActionsRenderer
    },

  ];
  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnFilter: true,
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: true,
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: null,
  };
  const FamilyDDChanged = (e) => {
    const familyId = e.value.map(item => item.FamilyId).join(',');
    SetfamilyIds([...e.value]);
    dispatch(getInvestorPortfolioAction(familyId, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy")));

  };
  const enterclick = () => {

    const famiyId = familyIds.map(
      (fam) => fam.FamilyId
    );
    const portfoliosId = portfolioIds.map(
      (por) => por.PortfolioId
    );
    const assetsId = assetId.map(
      (ass) => ass.AssetId
    );
    const typesId = typeIds.map(
      (typ) => typ.TransactionTypeId
    );

    const staId = statusIds.map(
      (sta) => sta.InvestorTrackingStatusId
    );
    dispatch(getInvestorTrackingList(investorTrackingId, famiyId, portfoliosId, assetsId, staId, typesId, moment(StartDate).format("MM-DD-yyyy"), moment(EndDate).format("MM-DD-yyyy"), groupId, TBD));
  }

const cancelclick=()=>
{
  SetfamilyIds([]);
  setPortfolioIds([]);
  settypeIds(val=>[]);
  SetstatusIds(val=>[]);
  SetAssetId([]);
  setSelectedUser({ UserId: "-1", Fullname: "Please Select" });
  setEndDate(endDate.format('MM-DD-YYYY'));
  setStartDate(startOfMonth.format('MM-DD-YYYY'));
  setTBD(false);
  setRender(value => value + 1); 
};
console.log(statusIds,typeIds,'123456789')
    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Tracker`, Routes: `${UrlPath.InvestorTracking}` }]
const deleteTransaction=async()=>{
  try {
    if(reasonForDeleting.trim()=="")
    {
      SBNotify({ Msg: "Please Enter the Reason For Deletion", type: "error" });
      return 
    }
    const res = await deleteTransactionTracker(selectedTransaction, reasonForDeleting);
    if (res) {
      SBNotify({ Msg: "Selected Transaction Deleted Successfully" });
      setShowDelete(false);
      setSelectedTransaction(null);
      setReasonForDeleting('');
      enterclick();
    }
  } catch (error) {
    SBNotify({ Msg: "Error Deleting the Transaction", type: "error"});
  }
};
const pdfview = (documentId, documentExtension, documentName) => {
  try {
    documentExtension = documentExtension.toLowerCase();
    if (
      documentExtension === ".pdf" ||
      documentExtension === ".xlsx" ||
      documentExtension === ".xls" ||
      documentExtension === ".png" ||
      documentExtension === ".jpg" ||
      documentExtension === ".jpeg" ||
      documentExtension === ".gif" ||
      documentExtension === ".doc" ||
      documentExtension === ".docx" ||
      documentExtension === ".ppt" ||
      documentExtension === ".pptx" ||

      documentExtension === "pdf" ||
      documentExtension === "xlsx" ||
      documentExtension === "xls" ||
      documentExtension === "png" ||
      documentExtension === "jpg" ||
      documentExtension === "jpeg" ||
      documentExtension === "gif" ||
      documentExtension === "doc" ||
      documentExtension === "docx" ||
      documentExtension === "ppt" ||
      documentExtension === "pptx"
    ) {
      const encodedDocumentId = btoa(documentId.toString());
      const urls = DownloadDocument + encodedDocumentId;
      sbaAxios({
        url: urls,
      }).then((response) => {
        window.open(urls);

      });
    }

    else {
      const encodedDocumentId = btoa(documentId.toString());
      const urls = DownloadDocument + encodedDocumentId;
      sbaAxios({
        url: urls,
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${documentName}.${documentExtension}`
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

      });
    }

  } catch (error) {
    console.error("Error opening document:", error);
  }
};
    return (
      <>
        <TopBar label={"Investor Tracker"} />
        <div id="InvestorTrackingList" className="mainContentData">
          <BreadCrumbs Levels={Level} />
          <div className="container-fluid">

          <div className="bg-white m-4 mb-3 p-3 border rounded">
            <form action="#">
              <div className="row border-bottom pb-3">
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Family</label>

                  <div>
                    <SBAMultiSelectCheck
                      className="w-75"
                      dataItemKey="FamilyId"
                      textField="FamilyName"
                      data={Family}
                      onChange={FamilyDDChanged}
                      Value={families}
                      tags={
                        familyIds?.length > 0
                          ? [
                            {
                              text: `${familyIds.length} items selected`,
                              data: [...familyIds],
                            },
                          ]
                          : []
                      }
                      filterable={true}
                      placeholder="Please Select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Portfolio</label>
                  <div>
                    <SBAMultiSelectCheck
                      data={Portfolios}
                      dataItemKey="PortfolioId"
                      textField="PortfolioName"
                      className="w-75"
                      onChange={PortfolioChanged}
                      Value={portfolio}
                      tags={
                        portfolioIds?.length > 0
                          ? [
                            {
                              text: `${portfolioIds.length} items selected`,
                              data: [...portfolioIds],
                            },
                          ]
                          : []
                      }
                      filterable={true}
                    ></SBAMultiSelectCheck>
                  </div>
                </div>
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Asset</label>
                  <div>
                    <SBAMultiSelectCheck
                      data={Assets}
                      dataItemKey="AssetId"
                      textField="AssetName"
                      className="w-75"
                      onChange={AssetDDChanged}
                      Value={assetId}
                      tags={
                        assetId?.length > 0
                          ? [
                            {
                              text: `${assetId.length} items selected`,
                              data: [...assetId],
                            },
                          ]
                          : []
                      }
                      filterable={true}
                    ></SBAMultiSelectCheck>
                  </div>
                </div>
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Status</label>
                  <div>
                    <SBAMultiSelectCheck
                      data={Status}
                      dataItemKey="InvestorTrackingStatusId"
                      textField="InvestorTRackingStatusName"
                      className="w-75"
                      onChange={statusChanged}
                      Value={statusIds}
                      tags={
                        statusIds?.length > 0
                          ? [
                            {
                              text: `${statusIds.length} items selected`,
                              data: [...statusIds],
                            },
                          ]
                          : []
                      }
                      filterable={true}
                    ></SBAMultiSelectCheck>
                  </div>
                </div>
              </div>

              <p className="fw-semibold mt-3">Filter by</p>
              <div className="row flex-wrap">
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Date Range</label>
                  <SBDateRangePicker
                    value={{ start: dateRange[0], end: dateRange[1] }}
                    onChange={(e) => { handleDateChange(e) }}

                  />
                  {/*<DateRangePicker*/}
                  {/*            className="SbaDateRage text-dark"*/}
                  {/*            placeholder="Select Date Range"*/}
                  {/*            value={[*/}
                  {/*                StartDate ? moment(StartDate).toDate() : new Date(),*/}
                  {/*                StartDate ? moment(EndDate).toDate() : new Date(),*/}
                  {/*            ]}*/}
                  {/*            format="MM/dd/yyyy"*/}
                  {/*            onChange={handleDateChange}*/}
                  {/*            block*/}
                  {/*            character=" - "*/}

                  {/*        />*/}
                </div>
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold fs-12">Transaction Type</label>
                  <SBAMultiSelectCheck
                    data={TransactionTypes}
                    dataItemKey="TransactionTypeId"
                    textField="TransactionTypeName"
                    className="w-75"
                    onChange={TransactionTypeDDChanged}
                    Value={typeIds}
                    tags={
                      typeIds?.length > 0
                        ? [
                          {
                            text: `${typeIds.length} items selected`,
                            data: [...typeIds],
                          },
                        ]
                        : []
                    }
                    filterable={true}
                  ></SBAMultiSelectCheck>
                </div>
                <div className="col-md-3">
                  <label for="select fund" className="mb-1 ms-2 fw-semibold  fs-12">Creator</label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      textField={"Fullname"}
                      valueField={"UserId"}
                      data={users}
                      value={selectedUser}
                      onChange={CreatoronChange}
                    />
                  </div>
                </div>

              </div>
              <div className="mt-3">
                <button type="button" className="enter-btn" onClick={enterclick}>Enter</button>
                <button type="button" className="cancel-btn ms-2" onClick={cancelclick}>Clear All</button>
              </div>
            </form>

          </div>
          <div className="bg-white m-4 mb-3 p-1 border rounded">
            <div className="mt-3 d-flex justify-content-between">
              <p className="fw-semibold p-0 py-1">Investor Tracker Activity</p>
              <div className="d-flex justify-content-end gap-2">
                <div>
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    disabled={!isEditable}
                  ><i className="fa-solid fa-plus" />
                    Add
                  </button>
                  <HoverList
                    isHovered={isHovered}
                    handleListMouseEnter={handleListMouseEnter}
                    handleListMouseLeave={handleListMouseLeave}
                  />
                </div> 
                {bulkEditAccess && <>
                  <button type="button" className="p-sm-btn mx-1" disabled={!isEditable} onClick={bulkuploadclick}>Bulk Edit</button>
              
                </>}
                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(investorGridRef, "Investor Tracker List.xlsx") }}><img src={download} alt="Excel" />Export</button>
              </div>
            </div>
            <div className="ag-theme-alpine p-1" style={{ pointerEvents: 'auto' }}>
              {TrackerGridLoading ? (
                <LoadingScreen />
              ) : (
                <>
                  <SBGrid    tooltipInteraction={true} tooltipShowDelay={0} ref={investorGridRef} excelStyles={excelStyles} suppressRowClickSelection={true} column={colDef} row={InvestorTrackingList} pageSize={15} rowSelection="multiple" filters={appliedFilter} componentID={1010} gridStyle={{ width: '100%', height: '700px' , pointerEvents: 'auto' }} onSelectionChanged={onSelectionChanged}
                  ></SBGrid>
                </>
              )}
            </div>

          </div>

        </div></div>
      {<Modal show={showDelete}  >
        <Modal.Header closeButton onClick={() => { setShowDelete(false); setReasonForDeleting(''); setSelectedTransaction(null) }}>
          <Modal.Title>Delete transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label className="header-container m-1">
              <b>Reason For Deletion</b>
            </label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                value={reasonForDeleting}
                onChange={(e) => { setReasonForDeleting(e.target.value) }}
                popupSettings={{ style: "z-index:1051", className: "modalDD" }}

              />
            </div>
            <br></br>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={() => { setShowDelete(false); setReasonForDeleting(''); setSelectedTransaction(null) }} > Cancel</button>
          <button className='p-sm-btn mx-1' onClick={() => { deleteTransaction() }} >
            Delete
          </button>
        </Modal.Footer>
      </Modal>}
      {showPDFModal && <Modal show={showPDFModal}  >
        <Modal.Header closeButton onClick={() => { setShowPDFModal(false); setPDFList([]) }}>
          <Modal.Title>Documents Attached</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ag-theme-alpine" style={{ width: '100%', pointerEvents: 'auto' }}>
              <AgGridReact
                rowData={PDFList}
                columnDefs={[{ field: 'DocumentName', headerName: 'Document Name', },
                { field: '', cellRenderer: FileDownloadComponent, maxWidth: 75 }]}
                defaultColDef={{ flex: 1 }}
              ></AgGridReact>
            </div>
          </Modal.Body>
          <Modal.Footer>
          {/* <button className="s-sm-btn mx-1" onClick={() => { setShowPDFModal(false); setPDFList([]) }} > Cancel</button>
          <button className='p-sm-btn mx-1' onClick={() => { deleteTransaction() }} >
            Delete
          </button> */}
        </Modal.Footer>
      </Modal>}
      <ToastContainer></ToastContainer>
    </>
  )
}

const HoverList = ({ isHovered, handleListMouseEnter, handleListMouseLeave }) => {
  const history = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  // const TransactionMenuList = Gstate.transactionList.transactionMenuList || [];
  const TransactionMenuList = [
    { DisplayName: 'Subscription' },
    { DisplayName: 'Redemption' },
    { DisplayName: 'Commitment' },
    { DisplayName: 'Capital Call' },
    { DisplayName: 'Distribution' },
    { DisplayName: 'Redeem - Fee' },
    { DisplayName: 'Redeem - Do Not Reallocate' }

  ];
  // useEffect(() => {
  //   if(isHovered === true)
  //   dispatch(getTransactionsMenuList(params.AssetId));
  // },[isHovered]);

  const handleItemClick = (item) => {
    let transType = item?.DisplayName?.trim();

    const mapping = {
      'Redeem - Fee': 'RedeemFee',
      'Redeem - Do Not Reallocate': 'RedeemReallocate'
    };
    transType = mapping[transType] || transType.replace(/\s/g, '');
    history(`${UrlPath.InvestorTracking}/${transType}/0`);
  };
  return (
    isHovered && (
      <div className="list-of-items" onMouseEnter={handleListMouseEnter} onMouseLeave={handleListMouseLeave}>
        {TransactionMenuList.map((item) => (
          <div
            key={item.DisplayName}
            onClick={() => handleItemClick(item)}
          >
            {item.DisplayName}
          </div>
        ))}
      </div>
    )
  );
};


const ToolTip = (props) => {
  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    sbaAxios({ url: getDocbyActivityId + props.data.ActivityId }).then(res => { setRowData(res) })
  }, [props]);
  const colDef = [
    { field: 'DocumentName', headerName: 'Document Name', },
    { field: '', cellRenderer: FileDownloadComponent , maxWidth:75},
  ]
  return <div className="ag-theme-alpine" style={{ width: '400px', pointerEvents: 'auto', height: '500px' }}>
    <AgGridReact
      rowData={rowData}
      columnDefs={colDef}
      defaultColDef={{ flex: 1 }}
    ></AgGridReact>
  </div>
};

const FileDownloadComponent = (props) => {
  const item = props.data;
  let content;
  const pdfview = (documentId, documentExtension, documentName) => {
    try {
      documentExtension = documentExtension.toLowerCase();
      if (
        documentExtension === ".pdf" ||
        documentExtension === ".xlsx" ||
        documentExtension === ".xls" ||
        documentExtension === ".png" ||
        documentExtension === ".jpg" ||
        documentExtension === ".jpeg" ||
        documentExtension === ".gif" ||
        documentExtension === ".doc" ||
        documentExtension === ".docx" ||
        documentExtension === ".ppt" ||
        documentExtension === ".pptx" ||

        documentExtension === "pdf" ||
        documentExtension === "xlsx" ||
        documentExtension === "xls" ||
        documentExtension === "png" ||
        documentExtension === "jpg" ||
        documentExtension === "jpeg" ||
        documentExtension === "gif" ||
        documentExtension === "doc" ||
        documentExtension === "docx" ||
        documentExtension === "ppt" ||
        documentExtension === "pptx"
      ) {
        const encodedDocumentId = btoa(documentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
        sbaAxios({
          url: urls,
        }).then((response) => {
          window.open(urls);

        });
      }

      else {
        const encodedDocumentId = btoa(documentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
        sbaAxios({
          url: urls,
          responseType: 'blob'
        }).then((response) => {
          const blob = new Blob([response]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${documentName}.${documentExtension}`
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

        });
      }

    } catch (error) {
      console.error("Error opening document:", error);
    }
  };
  switch (item?.DocumentExtension.toLowerCase()) {
    case 'pdf':
    case '.pdf':
      content = <i
        class="fas fa-file-pdf"
        style={{ color: "#F40F02" }}
        onClick={() =>
          pdfview(
            item.DocumentId,
            item.DocumentExtension
          )

        }
      ></i>;
      break;
    default:
      content = <i
        class="fas fa-file-excel"
        style={{ color: "#1D6F42" }}
        onClick={() =>
          pdfview(
            item.DocumentId,
            item.DocumentExtension
          )
        }
      ></i>;
      break;
  }

  return <>{content}</>;
};



export const getCurrencyFormat = (number, decimalnumber = 2, currencyCode = 'USD', locale = 'en-US') => {
  try {
    if (number == null || Number(number) === 0 || isNaN(Number(number))) {
      return '0';
    }
    const decimalPlaces = Math.max(0, parseInt(decimalnumber, 10) || 0);

    const formattedCurrency = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(Number(number));

    return formattedCurrency;
  } catch (error) {
    console.error('Error formatting currency:', error);
    return '';
  }
};